module.exports = __webpack_public_path__ + "static/fonts/open-sans-extrabold.907d99f.ttf";